import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { toggleTheme } from 'store/uiSlice';
import styles from './themeToggle.module.scss';

const ThemeToggle: React.FC = () => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.ui.theme);

  return (
    <button
      className={`${styles.themeToggle} ${theme === 'light' ? styles.lightMode : ''}`}
      onClick={() => dispatch(toggleTheme())}
      aria-label="Toggle theme"
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {theme === 'dark' ? (
        <Moon size={20} />
      ) : (
        <Sun size={20} />
      )}
    </button>
  );
};

export default ThemeToggle;
